import { render, staticRenderFns } from "./PatternTopNavBar.vue?vue&type=template&id=60928543&"
import script from "./PatternTopNavBar.vue?vue&type=script&lang=js&"
export * from "./PatternTopNavBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports